import {FaBriefcase, FaBuilding, FaHashtag, FaLink, FaUser, FaUsers} from 'react-icons/fa';

const ENTITY_PRESENTERS = {
    PROPERTY: {
        icon: FaBuilding,
        fallbackLabel: context => `Property ${context.entity_key}`,
    },
    JOB: {
        icon: FaBriefcase,
        fallbackLabel: context => `Job ${context.entity_key}`,
    },
};

export function ConversationIcon({kind}) {
    if (kind === 'CHANNEL') return <FaHashtag aria-hidden="true" />;
    if (kind === 'GROUP_DM') return <FaUsers aria-hidden="true" />;
    return <FaUser aria-hidden="true" />;
}

export function presentConversationContext(context) {
    if (!context) return null;
    const presenter = ENTITY_PRESENTERS[context.entity_type];
    const Icon = presenter?.icon || FaLink;
    return {
        Icon,
        label: context.label || presenter?.fallbackLabel(context) || `${context.entity_type} ${context.entity_key}`,
        status: context.status || 'available',
        entityType: context.entity_type,
        entityKey: context.entity_key,
    };
}

export function supportedChatEntityTypes() {
    return Object.keys(ENTITY_PRESENTERS);
}
